import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import Icon from "@components/icon";

import { useStore } from "../../../../connect";

import styles from "./Avatar.scss";

const cx = classnames.bind(styles);

const Avatar = ({ forBottomMenu }) => {
  const { baseUrl, profile } = useStore();

  let img;
  const showAvatarImg =
    profile.isLoggedIn && !profile.noProfile && profile.user.contact;
  if (showAvatarImg) {
    img = (
      <img
        className={cx("avatar-img")}
        src={`https://api.${baseUrl}/v2/avatars/${
          profile.user.ati_code
        }/contacts/${profile.user.contact.id || 0}`}
        alt="Аватар"
      />
    );
  } else if (forBottomMenu) {
    img = (
      <Icon
        name="ic_user-out"
        size="m"
        color="var(--glz-color-neutral-tone-5)"
      />
    );
  } else {
    img = (
      <Icon
        name="ic_human"
        size="m"
        color="var(--glz-color-neutral-tone-4)"
        opacity=".7"
      />
    );
  }

  return (
    <span
      className={cx("image-wrapper", {
        "for-bottom-menu": forBottomMenu,
        "with-border": profile.isLoggedIn,
        "with-background": showAvatarImg,
      })}
    >
      {img}
    </span>
  );
};

Avatar.propTypes = {
  forBottomMenu: PropTypes.bool,
};

export default observer(Avatar);
